module.exports = __webpack_public_path__ + "static/media/health2.27c39c8c.png";